exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".root---1dNfe{flex-grow:1;display:flex;flex-direction:column;position:relative}", ""]);

// Exports
exports.locals = {
	"root": "root---1dNfe"
};